import { BaseDialog } from './BaseDialog'

type ConfirmLogoutDialogProps = {
	open: boolean
	loading?: boolean
	onCancel: () => void
	onConfirm: () => void
}

export const ConfirmLogoutDialog = ({
	open,
	loading = false,
	onCancel,
	onConfirm,
}: ConfirmLogoutDialogProps) => {
	return (
		<BaseDialog
			open={open}
			title="Confirm Sign-out"
			onClose={onCancel}
			onConfirm={onConfirm}
			confirmText="Yes"
			cancelText="No"
			confirmButtonProps={{ loading, disabled: loading }}
			cancelButtonProps={{ disabled: loading }}
		>
			Are you sure you want to sign out?
		</BaseDialog>
	)
}
